import React from 'react'
import { initialStyleSetup, styleSetupConfig } from '../configs/style-config';
import { imageList } from '../configs/images-config';
import { StyleSetup } from '../models/style';
//AVCDAMOSHI.000  19/03/2025  Add code for  Add check register type page
type Props = {
    type: "confirm" | "error" | "loading";
    children? : React.ReactNode;
    handleClose?: () => void;
    image: string;
}

const PopupCustom = (props: Props) => {
    const [styles, setStyles] = React.useState<StyleSetup>(initialStyleSetup as StyleSetup);
    React.useEffect(() => {
      setSetupInitialConfig();
    }, []);

    function setSetupInitialConfig (){
      const stylesweb = window.sessionStorage.getItem('stylesetup');
      if (!stylesweb) {
        const initialStyles = styleSetupConfig();
        setStyles(initialStyles);
      }else {
        const parseJson = JSON.parse(stylesweb);
        const addTypeStyle = styleSetupConfig(parseJson);
        setStyles(addTypeStyle);
      }
    }

    const loading = props.type === "loading";
    return (
        <div className="popup-box" onClick={props.handleClose}>
          <div className="box" style={props.type === "confirm" ? styles.confirm_message_box_style : styles.error_message_box_style}>
            {!loading && <img src={props.image} alt="failedlogo" className={`img-correct ${loading ? " loading-icon" : ""}`} />}
            {loading && <h2>Loading....</h2>}
            {props.children}
            {loading && <img src={props.image} alt="failedlogo" className={`img-correct ${loading ? " loading-icon" : ""}`} />}
          </div>
        </div>
    );
};

export default PopupCustom

type PopupProps = {
  children: React.ReactNode;
  type: "error" | "success";
  style?: React.CSSProperties;
}

export const PopupBox = (props: PopupProps) => {
return (
  <div className='box-popup-dialog' style={props.style}>
      {props.type === "success" && <img src={imageList.correct_image} alt='error_image' className='img-correct'/>}
      {props.type === "error" && <img src={imageList.failed_image} alt='error_image' className='img-correct'/>}
      {props.children}
  </div>
)
}
//C-AVCDAMOSHI.000  19/03/2025  Add code for  Add check register type page